import { cn } from "@/utils/cn";
import { ButtonHTMLAttributes } from "react";

type IconButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  color?: "white" | "black";
  outline?: boolean;
};

const IconButton = ({
  className,
  type = "button",
  color = "white",
  outline = false,
  ...props
}: IconButtonProps) => {
  return (
    <button
      type={type}
      className={cn(
        "cursor-pointer: flex h-11 w-11 items-center justify-center rounded-full",
        "transition-all duration-200 ease-out hover:opacity-90 disabled:cursor-not-allowed disabled:opacity-60",
        "hover:bg-gray-100 hover:opacity-80 active:bg-gray-100",
        {
          "bg-white text-black": color === "white",
          "bg-black text-white": color === "black",
          "rounded-full border border-gray-300": outline,
        },
        className,
      )}
      {...props}
    />
  );
};

export default IconButton;
